import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import memo from "set-state-compare/build/memo"
import React from "react"
import Route from "@kaspernj/api-maker/build/router/route"
import Switch from "@kaspernj/api-maker/build/router/switch"
import {useWoofRouter} from "shared/woof-router"
/** @typedef {object} RoutesAdminSubscriptionPeriodsRouteProps */

/** @typedef {object} RoutesAdminSubscriptionPeriodsRouteState */

/**
 * @extends {ShapeComponent<RoutesAdminSubscriptionPeriodsRouteProps, RoutesAdminSubscriptionPeriodsRouteState>}
 */
class RoutesAdminSubscriptionPeriodsRoute extends ShapeComponent {
  setup() {
    this.woofRouter = useWoofRouter()
  }

  render() {
    return (
      <Switch name="subscription-periods">
        <Route component="edit" exact path="new" />
        <Route component="edit" exact path=":subscription_period_id/edit" />
        <Route component="show" exact path=":subscription_period_id" />
        <Route componentPath="fallback" fallback onMatch={this.tt.onFallbackMatch} />
      </Switch>
    )
  }

  onFallbackMatch = () => this.woofRouter.setPageNotFound(true)
}

export default memo(shapeComponent(RoutesAdminSubscriptionPeriodsRoute))
